const { hostname } = window.location;

export function isLocal(): boolean {
	return hostname.indexOf('localhost') !== -1;
}
